import { render, staticRenderFns } from "./purchaseRefundTask.vue?vue&type=template&id=4818e75c&scoped=true"
import script from "./purchaseRefundTask.vue?vue&type=script&lang=js"
export * from "./purchaseRefundTask.vue?vue&type=script&lang=js"
import style0 from "./purchaseRefundTask.vue?vue&type=style&index=0&id=4818e75c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4818e75c",
  null
  
)

export default component.exports